export * from './lib/components/product-detail/product-detail.component';
export * from './lib/components/product-detail/product-detail-field/product-detail-field.component';
export * from './lib/components/find-product/find-product.component';
export * from './lib/components/product-scan.component';

export * from './lib/artikelinfo.providers';
export * from './lib/artikelinfo.routes';
export * from './lib/product-scan.shared';
